import React, { useState } from 'react';
import moment from 'moment';
import {
  Box,
  Button,
	Card,
	CardContent,
	Divider,
  Grid,
	Paper,
	Tab,
	Tabs,
  TextField,
  Typography
} from '@material-ui/core';

import SalesRangePicker from 'components/Accounts/SalesRangePicker';
import SalesTable from 'components/Accounts/SalesTable';
import BookingsTable from 'components/Accounts/BookingsTable';
import MonthlyVATTable from 'components/Accounts/MonthlyVATTable';
import MonthlyCCTable from 'components/Accounts/MonthlyCCTable';
import DailyAccounts from 'components/Accounts/DailyAccounts';
import InvoicesDisplay from 'components/Accounts/InvoicesDisplay';

const months = [
  { month: '--Select Month--', num: -1 },
  { month: 'January', num: 0 },
  { month: 'February', num: 1 },
  { month: 'March', num: 2 },
  { month: 'April', num: 3 },
  { month: 'May', num: 4 },
  { month: 'June', num: 5 },
  { month: 'July', num: 6 },
  { month: 'August', num: 7 },
  { month: 'September', num: 8 },
  { month: 'October', num: 9 },
  { month: 'November', num: 10 },
  { month: 'December', num: 11 }
];

const AccountsDisplay = (props) => {
	
	const [tabValue, setTabValue] = useState(0);

	const [dates, setDates] = useState({});
	const [VATMonth, setVATMonth] = useState(-1);
	const [CCMonth, setCCMonth] = useState(-1);

	const [showBookings, setShowBookings] = useState(false);
	const [openSalesTable, setOpenSalesTable] = useState(false);
	const [openMonthlyVATTable, setOpenMonthlyVATTable] = useState(false);
	const [openMonthlyCCTable, setOpenMonthlyCCTable] = useState(false);
	const [openDailyAccounts, setOpenDailyAccounts] = useState(false);

	const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const showSalesTable = (dates, bookings) => {
    setShowBookings(bookings);
    setOpenSalesTable(true);
    setDates(dates);
  };

  const hideSalesTable = () => {
    setShowBookings(false);
    setOpenSalesTable(false);
    setDates({});
  };

  const showMonthlyVATTable = (event) => {
    setOpenMonthlyVATTable(true);
    setVATMonth(event.target.value);
  };

  const hideMonthlyVATTable = () => {
    setOpenMonthlyVATTable(false);
    setVATMonth(-1);
  };
  
  const showMonthlyCCTable = (event) => {
    setOpenMonthlyCCTable(true);
    setCCMonth(event.target.value);
  };

  const hideMonthlyCCTable = () => {
    setOpenMonthlyCCTable(false);
    setCCMonth(-1);
  };

  const hideDailyAccounts = () => {
    setOpenDailyAccounts(false);
  };

	return (
		<Box>
			<Box 
				sx={{
					display: 'flex',
					mb: 1
				}}
			>
				<Paper>
					<Tabs
						value={tabValue}
						indicatorColor="primary"
						textColor="primary"
            onChange={handleTabChange}
					>
						<Tab label="Sales"/>
						<Tab label="Reports"/>
						<Tab label="Invoices"/>
					</Tabs>
				</Paper>
        <Button
          color="primary"
          variant="contained"
          style={{ height: 48, width: 160, marginLeft: 16 }}
          onClick={props.hideAccountsDisplay}
        >
          Return
        </Button>
			</Box>
			<Card>
				<CardContent>
					<Box>
						{ tabValue === 0 ?
							(	openSalesTable ?
								( showBookings ?
									//isBetween(start, end, unit, "()"- both exclusive "[]"- both inclusive)
									<BookingsTable
										allSalesOrders={props.allSalesOrders.filter(SO => moment(SO.startDate).isBetween(dates.startDate, dates.endDate, 'day', '[]'))}
										dates={dates}
										hideSalesTable={hideSalesTable}
									/> :
									//isBetween(start, end, unit, "()"- both exclusive "[]"- both inclusive)
									<SalesTable
										salesOrders={props.salesOrders}
										expenses={props.expenses.filter(expense => moment(expense.createdAt).isBetween(dates.startDate, dates.endDate, 'day', '[]'))}
										dates={dates}
										hideSalesTable={hideSalesTable}
									/>
								) :
								<Box style={{ minHeight: 180 }}>
									<Typography
										style={{ marginTop: 8, marginBottom: 4 }}
										color="textPrimary"
										variant="h5"
									>
										Profit and Loss
									</Typography>
									<Divider />
									<Grid
										container
										justify='center'
										spacing={3}
										style={{ textAlign: 'center' }}
									>
										<Grid
											item
											md={3}
											xs={12}
										>
											<SalesRangePicker
												showSalesTable={showSalesTable}
												showBookings={false}
											/>
										</Grid>
										<Grid
											item
											md={3}
											xs={12}
										>
											<SalesRangePicker
												showSalesTable={showSalesTable}
												showBookings={true}
											/>
										</Grid>
									</Grid>
								</Box>
							)
						: null }
						{ tabValue === 1 ?
							<Box style={{ minHeight: 180 }}>
								<Typography
									style={{ marginTop: 8, marginBottom: 4 }}
									color="textPrimary"
									variant="h5"
								>
									Other Reports
								</Typography>
								<Divider />
								<Grid
									container
									justify='center'
									spacing={3}
									style={{ textAlign: 'center' }}
								>
									<Grid
										item
										md={3}
										xs={12}
									>
										<Typography
											style={{ marginTop: 16, marginBottom: 8 }}
											color="textPrimary"
											variant="body1"
										>
											Display Monthly VAT
										</Typography>
										<TextField
											select
											helperText="Please select the Month"
											label="Select Month"
											onChange={showMonthlyVATTable}
											SelectProps={{ native: true }}
											style={{ width: 360 }}
											value={VATMonth}
											variant="outlined"
										>
											{months.map((obj) => (
												<option
													key={obj.num}
													value={obj.num}
												>
													{obj.month}
												</option>
											))}
										</TextField>
									</Grid>
									<Grid
										item
										md={3}
										xs={12}
									>
										<Typography
											style={{ marginTop: 16, marginBottom: 8 }}
											color="textPrimary"
											variant="body1"
										>
											Display Monthly Cash / Card
										</Typography>
										<TextField
											select
											helperText="Please select the Month"
											label="Select Month"
											onChange={showMonthlyCCTable}
											SelectProps={{ native: true }}
											style={{ width: 360 }}
											value={CCMonth}
											variant="outlined"
										>
											{months.map((obj) => (
												<option
													key={obj.num} 
													value={obj.num}
												>
													{obj.month}
												</option>
											))}
										</TextField>
									</Grid>
									<Grid
										item
										md={3}
										xs={12}
									>
										<Typography
											style={{ marginTop: 16, marginBottom: 8 }}
											color="textPrimary"
											variant="body1"
										>
											Show Daily Account
										</Typography>
										<Button
											variant="outlined"
											style={{ height: 56, width: 360 }}
											onClick={() => setOpenDailyAccounts(true)}
										>
											Daily Account
										</Button>
									</Grid>
								</Grid>
								{ openMonthlyVATTable ?
								<MonthlyVATTable
									open={openMonthlyVATTable}
									month={VATMonth}
									salesOrders={props.salesOrders}
									expenses={props.expenses}
									closeModal={hideMonthlyVATTable}
								/> : null }
								{ openDailyAccounts ?
								<DailyAccounts
									open={openDailyAccounts}
									salesOrders={props.salesOrders}
									expenses={props.expenses}
									closeModal={hideDailyAccounts}
								/> : null }
								{ openMonthlyCCTable ?
								<MonthlyCCTable
									open={openMonthlyCCTable}
									month={CCMonth}
									salesOrders={props.salesOrders}
									closeModal={hideMonthlyCCTable}
								/> : null }
							</Box>
						: null }
						{ tabValue === 2 ?
							<InvoicesDisplay
								salesOrders={props.salesOrders}
								products={props.products}
								customers={props.customers}
								user={props.user}
							/>
						: null }
					</Box>
				</CardContent>
			</Card>
		</Box>
	)
};

export default AccountsDisplay;